export const CLASS_RELATED_CARDS_LIST = 'related-cards-list';
